"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _pagination = _interopRequireDefault(require("./pagination"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * An abstraction that provides a simple interface for managing
 * paginated collections of entities from the API.
 **/
var CollectionManager = /*#__PURE__*/function () {
  function CollectionManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$list = _ref.list,
        list = _ref$list === void 0 ? [] : _ref$list,
        _ref$pagination = _ref.pagination,
        pagination = _ref$pagination === void 0 ? _pagination["default"].create() : _ref$pagination,
        _ref$refreshing = _ref.refreshing,
        refreshing = _ref$refreshing === void 0 ? false : _ref$refreshing,
        _ref$loadingNextPage = _ref.loadingNextPage,
        loadingNextPage = _ref$loadingNextPage === void 0 ? false : _ref$loadingNextPage,
        _ref$filters = _ref.filters,
        filters = _ref$filters === void 0 ? {} : _ref$filters,
        _ref$ModelClass = _ref.ModelClass,
        ModelClass = _ref$ModelClass === void 0 ? null : _ref$ModelClass;

    (0, _classCallCheck2["default"])(this, CollectionManager);
    Object.assign(this, {
      list: list,
      pagination: pagination,
      refreshing: refreshing,
      loadingNextPage: loadingNextPage,
      filters: filters,
      ModelClass: ModelClass
    });
  } // Factory Function


  (0, _createClass2["default"])(CollectionManager, [{
    key: "update",

    /**
     * Update the collection.
     *
     * @param {object} data - API response data
     * @param {boolean} append - Optional, add to the current list if `true`. Replace the
     *                           current list if false. Defaults to `false`.
     */
    value: function update(data) {
      var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.list = [].concat((0, _toConsumableArray2["default"])(append ? this.list : []), (0, _toConsumableArray2["default"])(data.results));
      this.pagination = _pagination["default"].create(_objectSpread({}, this.pagination, {
        next: data.next,
        previous: data.previous,
        totalCount: data.count
      }));
      return this;
    }
    /**
     * Refresh the collection.
     */

  }, {
    key: "refresh",
    value: function () {
      var _refresh = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.refreshing = true;
                _context.prev = 1;
                _context.next = 4;
                return this.ModelClass.api.list({
                  pagination: this.pagination,
                  filters: this.filters
                });

              case 4:
                response = _context.sent;
                return _context.abrupt("return", this.update(response));

              case 6:
                _context.prev = 6;
                this.refreshing = false;
                return _context.finish(6);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 6, 9]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
    /**
     * Advance to the next page and refresh the collection.
     */

  }, {
    key: "nextPage",
    value: function nextPage() {
      this.pagination.setNextPage();
      return this.refresh();
    }
    /**
     * Go back to the previous page and refresh the collection.
     */

  }, {
    key: "prevPage",
    value: function prevPage() {
      this.pagination.setPrevPage();
      return this.refresh();
    }
    /**
     * Get the next page for a collection and add this page
     * to the collection.
     */

  }, {
    key: "addNextPage",
    value: function () {
      var _addNextPage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.pagination.next === null)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                this.loadingNextPage = true;
                this.pagination = _pagination["default"].create(_objectSpread({}, this.pagination, {
                  page: this.pagination.page + 1
                }));
                _context2.prev = 4;
                _context2.next = 7;
                return this.ModelClass.api.list({
                  pagination: this.pagination,
                  filters: this.filters
                });

              case 7:
                response = _context2.sent;
                return _context2.abrupt("return", this.update(response, true));

              case 9:
                _context2.prev = 9;
                this.loadingNextPage = false;
                return _context2.finish(9);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4,, 9, 12]]);
      }));

      function addNextPage() {
        return _addNextPage.apply(this, arguments);
      }

      return addNextPage;
    }()
  }], [{
    key: "create",
    value: function create() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opts = opts || {};
      return new CollectionManager(opts);
    }
  }]);
  return CollectionManager;
}();

exports["default"] = CollectionManager;